export default {"src":"/ui/_next/static/media/not-found.96996d73.svg","height":790,"width":1010,"blurWidth":0,"blurHeight":0};